import React, { FC } from "react";
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import { clss } from "../../../../utils/helpers/styleHelpers";
import { useState } from "react";
import Icon from "../../../Icon/Icon";
import { IconColorE } from "../../../../models/enums";
import { useAppSelector } from "../../../../store/hooks";
import { selectDirection } from "../../../../store/selectors/appSelectors";
import { LATIN_AND_NUMBERS_REG_EXP, NUMBERS_ONLY_REG_EXP } from "../../../../utils/regexps";

import styles from "../../form.module.scss";

type InputFieldPropTypes = {
  name: string;
  label: string;
  errorMessage: string;
  hintText?: string;
  type: string;
  register: any;
  orderIndex: number;
  defaultValue: any;
  style: any;
  props: any;
  onChange: (value: any) => void;
  extraContent: any;
  placeholder: string;
  capitalLetters: boolean;
  onlyLettersAndNumbers?: boolean;
  onlyNumbers?: boolean;
  onInput?: (value: string) => string;
  className?: string;
};

const InputField: FC<InputFieldPropTypes> = (props) => {
  const {
    name,
    label,
    errorMessage,
    type,
    hintText,
    register,
    orderIndex,
    defaultValue,
    style,
    props: outerProps,
    onChange,
    extraContent,
    placeholder,
    capitalLetters,
    onlyLettersAndNumbers,
    onlyNumbers,
    onInput,
    className: outerClassName
  } = props;

  const [showInputData, setShowInputData] = useState(type !== "password");
  const direction = useAppSelector(selectDirection);

  // react-hook-form's onChange has to be composed, not replaced: spreading register() and then
  // declaring onChange below overrode it, so RHF kept whatever the input held when it was first
  // registered and the submitted `data` never saw what the user typed. (This is why editing the
  // campaign's custom name in the wizard silently did nothing.)
  const { onChange: registerOnChange, ...registration } = register(
    name as `${string}`
  );

  return (
    <div key={name} style={{ order: orderIndex, ...style }}>
      <Label label={label} name={name} hintText={hintText}>
        <input
          type={type === 'password' ? showInputData ? 'text' : 'password' : type}
          {...registration}
          className={clss([
            styles.field,
            errorMessage ? styles.errorField : "",
            outerClassName || "",
          ])}
          defaultValue={defaultValue}
          {...outerProps}
          onChange={(e) => {
            registerOnChange(e);
            onChange(e.target.value);
          }}
          dir={direction}
          placeholder={placeholder}
          onInput={(e) => {
            let res = e.currentTarget.value;

            if (capitalLetters) {
              res = res.toUpperCase();
            }
            if (onlyLettersAndNumbers) {
              res = res.replace(LATIN_AND_NUMBERS_REG_EXP, '')
            }
            if (onlyNumbers) {
              res = res.replace(NUMBERS_ONLY_REG_EXP, '')
            }

            if (onInput && onInput(res)) {
              res = onInput(res);
            }

            e.currentTarget.value = res;
          }}
        />
        {type === "password" && (
          <Icon
            name={showInputData ? "eyeClosed" : "eye"}
            color={IconColorE.DARK_GRAY}
            className={styles.eyeIcon}
            onClick={() => setShowInputData((prev) => !prev)}
          />
        )}
      </Label>
      <ErrorText text={errorMessage} />
      {!!extraContent && extraContent()}
    </div>
  );
};

export default InputField;
